import React from "react";

function AddForm(props){
    return(
        <div class="input-modal">
        <form>
        <strong>Activity:</strong><input type="text" id="activity" required placeholder="Ex: Reading"></input> <br/>
        <strong>Hours:</strong><input type="number" id="hours" class="time_input" required ></input>
        <strong>Minutes:</strong> <input type="number" id="minutes" class="time_input" required ></input> <br/>
        <strong>Productive:</strong>
        <input type="radio" name="productive" id="radio-y" required checked></input> Yes 
        <input type="radio" name="productive" id="radio-n" required></input> No
        <br />
        {!props.disableForm && <button onClick={props.click}>Submit</button>}
        <button type="reset">Clear</button>
        </form>
        </div>
    )
}


export default AddForm;